import styled from "styled-components";

export const Wrapper = styled.div`
  height: 100%;
  display:flex;
  justify-content: left;
  width: 100%;
  flex-direction: column;
`;
